import React, { useEffect, useState } from 'react';
import Card from '../Card/Card';
import Const from 'const.json';
import ChartBar from '../Charts/ChartBar/ChartBar';
import { ActiveComponentEnum, GenderEnum, MediaQuery } from 'enums/enums'
import ListItem from 'components/controls/ListItem/ListItem';
import { useAppSelector } from '../../redux/hooks';
import { ChartBarDetails } from 'types/Chart';
import WithApi from 'components/ui/WithApi/WithApi';
import useApi from 'hooks/useApi';
import { GetComplaintSubjectsGenderGap, GetTopRootSubjectsGenderGapDetail } from 'api/apiService';
import { GenderGapData } from 'types/GenderGap';
import useMediaQuery from 'hooks/useMediaQuery';
import { numberWithCommas, pluginsDefinitions } from 'utils/utils';

const ComplaintSubjectsGenderGap: React.FC = () => {
    
    const [activeComponent, setActiveComponent] = useState(ActiveComponentEnum.Chart);
    const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
    const isMobile = useMediaQuery(MediaQuery.Mobile);
    const { period, isContrast } = useAppSelector((state) => state.general);
    const { callApi, data = [], loading, error } = useApi<GenderGapData[]>(GetComplaintSubjectsGenderGap);

    const colorDictionary = {
        [GenderEnum.Male]: isContrast ? '#ADD8E6' : "#394491",
        [GenderEnum.Female]: isContrast ? '#FFC0CB' : "#67d9eb"
    }

    useEffect(() => {
        callApi();
        setSelectedIndex(null);
        setActiveComponent(ActiveComponentEnum.Chart);
    }, [period]);

    // nav to details  
    const onDetailClick = (index: number) => {
        setSelectedIndex(index);
        setActiveComponent(ActiveComponentEnum.EntityDetails);
    }

    // nav back from details to chart
    const handleNavigation = (componentName: ActiveComponentEnum) => {
        setActiveComponent(componentName);
        setSelectedIndex(null);
    };

    const details = detailsForChart(data || [], colorDictionary, isContrast)

    const selectedComplaint = selectedIndex !== null && data && data.length && data[0].data[selectedIndex]!
    const formatter = isMobile ? null : getFormmater()
    return (
        <div>
            {activeComponent === ActiveComponentEnum.Chart && (
                <Card header={Const.complaintSubjectsGenderGap} isTooltip={true} tooltipContent={Const.tooltipContentComplaintSubjectsGenderGap} components={[
                    <WithApi data={data} loading={loading} error={error}>
                        <ChartBar
                            ariaLabel={getAriaLabel(data)}
                            details={details}
                            chartBarYAxisHeader={Const.chartBarYAxisHeader}
                            formmater={formatter}
                            onDetailClick={onDetailClick}
                            isHaveDetail={true}
                            displayLabels={!isMobile}
                        />
                    </WithApi>
                ]} />)}
            {activeComponent === ActiveComponentEnum.EntityDetails && (
                <Card
                    components={[
                        <ListItem
                            onNavigate={handleNavigation}
                            navigateTo={ActiveComponentEnum.Chart}
                            complaint={selectedComplaint}
                            fetchDetails={GetTopRootSubjectsGenderGapDetail}
                            isShowDetails={true}
                            isShowLogo={false}
                            sumComplaints={data && (data[0]?.data[selectedIndex]?.complaintsCount + data[1]?.data[selectedIndex]?.complaintsCount)}
                        />,
                    ]}
                />
            )}
        </div>
    );
};
export default ComplaintSubjectsGenderGap;

const getAriaLabel = (data: GenderGapData[]):string => {
    let ariaLabel = Const.complaintSubjectsGenderGap + ' '; 
    if(data)
        return ariaLabel + data[0]?.data.map((subject, index) => `${Const.subject} ${subject?.description}: ${Const.men}- ${subject?.complaintsCount} ${Const.complaints}, ${Const.women}- ${data[1]?.data[index]?.complaintsCount} ${Const.complaints}`).join(', ');
    else return ariaLabel;
}

const getFormmater = () => (value: any, context: any) => {
    const datasets = context.chart.data.datasets;
    const dataIndex = context.dataIndex;
    const datasetIndex = context.datasetIndex;
    const percent = Math.round((value / (datasets[datasetIndex].data[dataIndex] + datasets[Math.abs(datasetIndex - 1)].data[dataIndex])) * 100);
    return `${numberWithCommas(value)}\n(${percent}%)`;
}

const detailsForChart = (details: GenderGapData[], colorDictionary: {}, isContrast: boolean): ChartBarDetails => {
    let barLabelData: string[][] = [];
    const dataSets = details.map(dataset => {
        barLabelData = dataset.data.map(el => [el.description])
        return {
            ...dataset,
            color: isContrast ? 'white' : 'gary',
            backgroundColor: colorDictionary[dataset.gender],
            pointStyle: "circle",
            datalabels: {},
            data: dataset.data.map(el => el.complaintsCount),
        }
    })
    return {
        barLabelData,
        datasets: dataSets,
        plugins: pluginsDefinitions(isContrast),
    }
}